import { createSlice } from '@reduxjs/toolkit';

export const cartItemsSlice = createSlice({
	name: 'cartItems',
	initialState: {
		data: [],
	},
	reducers: {
		setCartItems: function (state, action) {
			state.data = action.payload;
		},

		addCartItems: function (state, action) {
			action.payload.forEach((data, index) => {
				// we will check if an item already exist
			});
			state.data.push(...action.payload);
		},

		updateCartItem: function (state, action) {
			state.data[state.data.findIndex(item => item.item_code === action.payload.item_code)] = action.payload;
		},

		removeCartItem: function (state, action) {
			state.data = state.data.filter(item => item.item_code !== action.payload);
		},
	},
});

export const { setCartItems, addCartItems, updateCartItem, removeCartItem } = cartItemsSlice.actions;
export default cartItemsSlice.reducer;
